module.exports = __webpack_public_path__ + "static/media/comparative.b227806e.svg";